import React from 'react'
import WidgetComponent from './widgetComponent'
import { Link } from 'react-router-dom'
import context from '@/context'
import WidgetContent from '@/components/messages/widgetContent'
import Resx from '@/components/Resx'

class MessagesWidget extends WidgetComponent {
  headerButtons () { return <Link to='/messages'><Resx name='Common.More' /></Link> }
  widgetIcon () { return 'icon-building' }
  widgetTitleKey () { return 'Messages.WidgetTitle' }
  dataSource () { return context.api.messagesService.getSentMessages(addSorting(this._prepareDataSourceRequest(this.props.widgetItem))) }
  renderContent (data) { return <WidgetContent data={data.data} /> }
}
const addSorting = (request) => {
  if (!request) { request = {} }
  request.sort = [{ field: 'sendingTime', dir: 'desc' }]

  return request
}

export {
  MessagesWidget
}



// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/messages.js